import { useState, useEffect, useCallback } from "react";
import type { User } from "../../shared/types";
import { api } from "../services/api";

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({
    user: null,
    loading: true,
    error: null,
  });

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setState({ user: null, loading: false, error: null });
      return;
    }

    try {
      const user = await api.getMe();
      setState({ user, loading: false, error: null });
    } catch {
      api.clearToken();
      setState({ user: null, loading: false, error: null });
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (username: string, password: string) => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    try {
      const result = await api.login({ username, password });
      setState({ user: result.user, loading: false, error: null });
      return result.user;
    } catch (error) {
      const message = error instanceof Error ? error.message : "登录失败";
      setState((prev) => ({ ...prev, loading: false, error: message }));
      throw error;
    }
  };

  const logout = () => {
    api.logout();
    setState({ user: null, loading: false, error: null });
  };

  return {
    ...state,
    login,
    logout,
    checkAuth,
  };
}
